module.exports = __webpack_public_path__ + "media/MOCAM-1080p-Pairing-Mode_Light.40187748.mp4";